import { render } from "./FormSearch.vue?vue&type=template&id=077447c0&ts=true"
import script from "./FormSearch.vue?vue&type=script&lang=ts"
export * from "./FormSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__